module.exports = __webpack_public_path__ + "77a9b23a6ca0adbccb2c9e46f680c4ae.png";